export default "__VITE_ASSET__CrZiFZNV__"